import { CommonModule } from '@angular/common';
import { Component, Input, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-card-empresa',
  imports: [CommonModule, AvatarModule],
  templateUrl: './card-empresa.component.html',
  styleUrl: './card-empresa.component.scss',
  standalone: true,
})
export class CardEmpresaComponent {
  getInitials(name?: string | null): string {
    return getInitials(name);
  }
  constructor(private router: Router) {}
  private route = inject(ActivatedRoute);

  // Inputs
  name = input<string>();
  description = input<string>();
  country = input<string>();
  phone = input<string>();
  email = input<string>();

  @Input() instituicaoEnsino: any;

  private _logo: string | null = null;

  @Input() set logo(value: string | ArrayBuffer | null) {
    // Só aceita base64 de imagem
    if (typeof value === 'string' && value.startsWith('data:image/')) {
      this._logo = value;
    } else {
      this._logo = null;
    }
  }

  get logo() {
    return this._logo;
  }

  Show = false;

  ShowDetais(event: Event) {
    event.stopPropagation();
    this.Show = !this.Show;
  }

  AddRepresent(event: Event) {
    event.stopPropagation();
    this.router.navigate([
      '/gestao-bolseiros/instituicao-ensino/add-representante',
      this.instituicaoEnsino.id,
    ]);
  }

  get routeId() {
    return this.route.snapshot.paramMap.get('id');
  }

  routerLink() {
    this.router.navigate([
      '/gestao-bolseiros/instituicao-ensino/detalhe-instituicao/',
      this.instituicaoEnsino.id,
    ]);
  }

  onImageError() {
    this._logo = null;
  }
}
